// extracted by mini-css-extract-plugin
module.exports = {"top":"indexLayout-module--top--2Ikp0","table":"indexLayout-module--table--hRPB0"};